// vuex-loading
import { createActionHelpers } from 'vuex-loading'
const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const api = {}
const files = require.context('./endpoints', true, /\.js$/)

// TODO: Current caveat is that we can't have multiple endpoints with the same name.
// For e.g.: Users/GetAll and Locations/GetAll since both will be technically be named GetAll
// We need to find a way to identify [controller]/[action] instead
files.keys().forEach(path => {
  const endpoint = files(path)
  Object.keys(endpoint).forEach(x => {
    Object.keys(endpoint[x]).forEach(y => {
      Object.defineProperty(api, y, { value: endpoint[x][y] })
    })
  })
})

export { api, startLoading, endLoading }



// WEBPACK FOOTER //
// ./src/api/index.js